/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import ImageLayer from 'ol/layer/image';
import { layer } from '../core';

/** @module image-layer/layer */
/**
 * @vueProps
 */
var props = /** @lends module:image-layer/layer# */{};

/**
 * @vueMethods
 */
var methods = /** @lends module:image-layer/layer# */{
  /**
   * @return {ol.layer.Image}
   * @protected
   */
  createLayer: function createLayer() {
    return new ImageLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      extent: this.extent,
      zIndex: this.zIndex,
      source: this._source
    });
  }
};

/**
 * Layer for server-rendered images that are available for arbitrary extents and resolutions.
 *
 * @title vl-layer-image
 * @alias module:image-layer/layer
 * @vueProto
 *
 * @vueSlot default Default slot for `vl-source-*` (image-like only) components.
 */
var Layer = {
  name: 'vl-layer-image',
  mixins: [layer],
  props: props,
  methods: methods
};

/** @module image-layer */
/**
 * @alias module:image-layer
 *
 * @example Install
 * import Vue from 'vue'
 * // import module and styles
 * import { ImageLayer } from 'vuelayers'
 * // or
 * import ImageLayer from 'vuelayers/lib/image-layer'
 * // import VueLayers styles
 * import 'vuelayers/lib/style.css'
 * // register components
 * Vue.use(ImageLayer)
 */
var index = {
  /**
   * Layer for server-rendered images that are available for arbitrary extents and resolutions.
   * @alias module:image-layer/layer
   */
  Layer: Layer,
  install: function install(Vue) {
    Vue.component(Layer.name, Layer);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/image-layer/index.es.js
// module id = null
// module chunks = 